import { StatusDtoOrderStatusEnum } from 'utils/types/OrderModels';
import { ProductPurchaseStateType } from 'utils/types/ProductPurchase';

import { initialErrorState, initialInvoiceState } from 'components/common/Purchase/ProductPurchaseForm';
import { PurchaseProductEnum } from 'components/common/Purchase/PurchaseStatusInfo';

export const POLLING_INTERVAL_MS = 5000; // 5 sekund
export const POLLING_TIMEOUT_MS = 18 * 60 * 1000; // 18 minut

export const productPurchaseInitialState: ProductPurchaseStateType = {
    invoiceData: initialInvoiceState,
    errors: initialErrorState,
    triggerValidation: false,
    processStep: '',
    isLoading: false,
    isPolling: false,
    status: StatusDtoOrderStatusEnum.PENDING,
    showPurchaseStatus: false,
    cart: null,
    isLoadingCart: false,
    isInitializing: true,
    currentOrder: null,
    productType: PurchaseProductEnum.SMS,
    initialQuantity: 0
};

export const getProductIdByType = (productType: PurchaseProductEnum): number => {
    switch (productType) {
    case PurchaseProductEnum.SMS:
        return 1; // ID produktu SMS w systemie
    case PurchaseProductEnum.TOKENS:
        return 2; // ID produktu AI_TOKENS w systemie
    default:
        throw new Error(`Unknown product type: ${productType}`);
    }
};

export const convertQuantityForApi = (productType: PurchaseProductEnum, displayQuantity: number): number => {
    if (productType === PurchaseProductEnum.TOKENS) {
        return displayQuantity / 100000;
    }

    return displayQuantity;
};

export const initialState = {
    productPurchaseInitialState: () => productPurchaseInitialState
};
